export enum JourneyType {
    RENEWAL = 'RENOUVELLEMENT',
    ACQUISITION = 'ACQUISITION',
}
